import { Component, Input, OnInit } from '@angular/core';

import * as _ from 'lodash';

import { UntypedFormGroup } from '@angular/forms';

import { StateService } from '@uirouter/angular';
import { ProjectRegistrationHelper } from '../project.registration.helper';
import { ProjectService } from '../../../../services/project.service';
import { SearchService } from '../../../../services/core.search.service';
import { ProjectModel } from '../../../../services/project.model.service';

@Component({
	selector: 'org-registration-main',
	template: require('./org.registration.main.html'),
})
export class OrgRegistrationMainComponent implements OnInit {
	childOpts: any[] = [];
	@Input() projectForm: UntypedFormGroup = null;

	children = {
		items: [] as any[],
		opts: [] as any[],
		search: '',
		searching: false
	};

	parent = {
		item: null,
		opts: [] as any[],
		search: '',
		searching: false
	};

	constructor(
		private stateService: StateService, 
		
		protected projectRegistrationHelper: ProjectRegistrationHelper,
		protected projectModel: ProjectModel,
		private projectService: ProjectService,
		private searchService: SearchService
	) { }

	ngOnInit(): void {
		this.children.items = this.projectForm.get('children')?.value || [];
		this.parent.item = this.projectForm.get('parentProject')?.value || null;
	}

	protected searchParents = _.debounce(() =>
		this.doSearch(this.parent, {
			page_size: 99,
			q: this.parent.search,
			canChild: 2147483647
		}
	), 500);

	protected searchChildren = _.debounce(() => 
		this.doSearch(this.children, {
			page_size: 99,
			q: this.children.search,
			canChild: 2147483647
		}
	), 500);

	doSearch(searchObj: any, params: any) {
		if (! searchObj.search) {
			searchObj.opts = [];
			searchObj.searching = false;
			return;
		}

		searchObj.searching = true;
		this.searchService.searchProjects(params)
		.then((ret: any) => {
			searchObj.opts = ret.items;
			searchObj.searching = false;
		}, () => {
			searchObj.opts = [];
			searchObj.searching = false;
		});
	}

	canAddChild(children, child, parentId) {
		var found = _.find(children, function (item) {
			return item.id == child.id || item.id == parentId;
		});
		return !found;
	}

	canSetParent(children, parent) {
		var inChildren = _.find(children, function (item) {
			return item.id == parent.id;
		})
		return !inChildren;
	}

	setParent(parent) {
		var validParent = this.canSetParent(this.children.items, parent);
		if (validParent) {
			this.parent.item = {
				id: parent.refId,
				name: parent.title,
				unixName: parent.project,
			};

			this.parent.search = '';
		}
	}

	addChild(child) {
		if (this.canAddChild(this.children.items, child, _.get(this.parent, 'item.id', 0))) {
			this.projectService.fetch({ id: child.refId })
				.then(
					(response) => this.children.items.push(response),
					(rejection) => console.log(rejection)
				);
		}
		this.children.search = '';
	};

	removeChild(child) {
		this.children.items = _.reject(this.children.items, (item: any) => {
			return item.id == child.id;
		})
	}
}
